var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cc7ebd4ed35a6b2808c381e05de0ffbac740faa4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["policy-expert-site@qmetric"]={id:"cc7ebd4ed35a6b2808c381e05de0ffbac740faa4"};
      